export default __webpack_public_path__ + "static/media/cheers.45269020.m4a";